/**
 * @fileOverview
 * @name queryparameter.ts
 * @author Taketoshi Aono
 * @license
 */

export const QUERY_PARAMETER_KEY = '_aimdbg';
